<template>
      <reverso-msg v-if="templateType === 14" :message="message"></reverso-msg>
      <node-msg v-else-if="templateType === 16" :message="message"></node-msg>
</template>

<script>
import ReversoMsg from '../model-sub-msg/ReversoMsg';
import NodeMsg from '../model-sub-msg/NodeMsg';
export default {
  props: {
    message: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    templateType() {
      return this.message?.content?.content?.type;
    },
  },
  components: {
    ReversoMsg,
    NodeMsg,
  },
};
</script>
